// 의존성 없는 순수 모듈로 둔다. helpers.js 는 fflate 와 configs 를 끌어오고 확장자
// 없는 import 를 써서 번들러 없이는 못 읽는데, 이 각도 산술은 실제로 틀린 적이 있어
// (누적 오프셋이 ±180 을 넘으면 음수 % 로 각도가 튀었다) 단독으로 검사할 수 있어야 한다.
// 검사: node tools/test-wrap-angle.mjs

/**
 * Wraps a bearing, or a difference of two bearings, into [-180, 180).
 *
 * The naive form `(deg + 540) % 360 - 180` only holds while `deg > -540`, because
 * JavaScript's `%` keeps the sign of the dividend: at deg = -600 it returns -240
 * instead of 120. Taking `% 360` first bounds the input before the shift.
 *
 * Half a turn lands on -180, not +180. They are the same heading, so no caller
 * cares, but the test pins it so the boundary can't drift unnoticed.
 *
 * @param {number} deg - Angle in degrees, any magnitude
 * @returns {number} Equivalent angle in [-180, 180)
 */
export function wrapAngle(deg) {
    return (deg % 360 + 540) % 360 - 180;
}
